( function( $ ){

    $( '.searchform-clear' ).on( 'click', () => {
        $( '.searchform-container .search-input' ).val('');
        $( '.searchform-container .search-input' ).focus();
    });

})( jQuery );